import {
	Button
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Form from "@rjsf/material-ui";
import React, { useState } from 'react';
import { useActions } from 'kea';

import userlogic from 'src/store/user';

import { formSchema, uiSchema } from './schema';

let modifiedFormSchema = JSON.parse(JSON.stringify(formSchema));

const AddDialog = ({ all_roles }) => {

	const { create } = useActions(userlogic);

	const [open, setOpen] = useState(false);

	modifiedFormSchema.properties.roles.items.anyOf = all_roles.map((role) => {
		return {
			enum: [role],
			title: role
		}
	})

	delete modifiedFormSchema.properties.Enabled;

	const handleClickOpen = () => {
		setOpen(true);
	}

	const handleClose = () => {
		setOpen(false);
	}

	const validate = (formData, errors) => {
		if (formData.email !== formData.repeat_email) {
			errors.repeat_email.addError('Email must match')
		}
		let mobile_pattern = new RegExp(/(^0[0-9]{9}$)|(^61[0-9]{8}$)/);
		var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
		if (!pattern.test(formData.email)) {
			errors.email.addError('Invalid Email');
		}
		if (!mobile_pattern.test(formData.mobile)) {
			errors.mobile.addError('Invalid Phone number. Please check for correct lenth or digits only.');
		}
		if (!pattern.test(formData.repeat_email)) {
			errors.repeat_email.addError('Invalid Email');
		}
		return errors;
	}

	const onSubmit = (value, callback) => {
		create(value.formData);
		setOpen(false);
	};

	return (
		<div style={{ paddingTop: '15px' }}>
			<Button
				color="primary"
				variant="contained"
				aria-label="add"
				onClick={handleClickOpen}
			>
				New User
			</Button>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Add a new user
				</DialogTitle>
				<DialogContent>
					<Form
						schema={modifiedFormSchema}
						onSubmit={onSubmit}
						uiSchema={uiSchema}
						validate={validate}
						// liveValidate
						showErrorList={false}
					>
						<div style={{ textAlign: 'center', paddingTop: '15px' }}>
							<Button type={'submit'} variant="contained" color="primary">
								Add
							</Button>
						</div>
					</Form>
				</DialogContent>
				<DialogActions>
				</DialogActions>
			</Dialog>
		</div>
	)
}


export default AddDialog
